import React, { forwardRef, useRef, useState, useImperativeHandle } from "react";
import { RCCBadge, RCCGrid, RCCHookToast, RCCRefModalProps, RCCServicesApi } from "react-common-components";
import Modal from "src/components/Modal";
import ModalSide from "src/components/Modal/styles";
import Photo from "src/components/Photo";
import Title from "src/components/Title";
import { useLoaderBackdrop } from "src/context/LoaderBackdrop/context";
import { useTranslation } from "src/context/Translations/context";
import { standardErrorMessages } from "src/utils/errors";
import formatDate from "src/utils/formatDate";
import {  IActionShowPostponementRef, IPostponement } from "../interface";
import { SpanComment } from "./FormSimplifiedFields/styles";
import ContainerValues, { ColumnFlex, ContainerUser } from "./History/styles";

const ModalShowPostponements: React.ForwardRefRenderFunction<IActionShowPostponementRef> = (_, ref) => {

	const { translate, currentLanguage } = useTranslation();
	const { addToast } = RCCHookToast();
	const { setLoading } = useLoaderBackdrop();

	const { REACT_APP_S3_ADDRESS, REACT_APP_S3_DIRECTORY } = process.env;

	// Modal postponement
	const modalShowPostponement = useRef<RCCRefModalProps>(null);

	const [subtitle, setSubtitle] = useState<string | undefined>(undefined);
	
	// Modal confirm postponement
	const [postponements, setPostponements] = useState<IPostponement[]>([]);

	const openModalActionShowPostponements = async (id: number, titleAction: string, defaultPostponement?: IPostponement[]) => {

		if(defaultPostponement){
			setPostponements(defaultPostponement);
			setSubtitle(titleAction);
			modalShowPostponement.current?.openModal();
			return; 
		}
		
		try{
			setLoading(true);
			const {data} = await RCCServicesApi.getRequest({
				method: "Actions/ListPostponements",
				urlParameters: {
					id
				}
			});
			setSubtitle(titleAction);
			setPostponements(data);
			setLoading(false);
			modalShowPostponement.current?.openModal();
		}catch(err){
			setLoading(false);
			standardErrorMessages(err, translate("Erro ao buscar histórico"), addToast);
		}
	};

	const badgeSituation = (situation?: string) => {

		let textBadge = "";
		let colorBadge: "green" | "red" | "grey" = "grey";
	
		switch (situation) {
		case "S":
			textBadge = translate("Aprovada");
			colorBadge = "green";
			break;
		case "N":
			textBadge = translate("Rejeitada");
			colorBadge = "red";
			break;
		default:
			textBadge = translate("Requer confirmação");
			colorBadge = "grey";
			break;
		}

		return (
			<RCCBadge color={colorBadge} styleInline="padding: 2px 8px; font-size: 0.78rem;">
				{textBadge}
			</RCCBadge>
		);
	};


	useImperativeHandle(ref, () => ({
		openModalActionShowPostponements
	}));

	return (
		<>
			{/* Modal create postponement */}
			<Modal 
				ref={modalShowPostponement}
				header={{
					title: translate("Postergações"),
					subtitle: `${translate("Ação")}: ${subtitle}`,
					icon: {
						name: "calendar"
					}
				}}
				footer= {{
					showSaveButton: false,
					cancelButtonText: translate("Fechar")
				}}
				withoutForm
				styleInline={ModalSide}
			>
				
				{postponements && postponements?.map((inb003) => (
					<RCCGrid
						key={`postponement-list-${inb003.inb003Id}`}
						container
						item
						xs={12}
					>
						<RCCGrid 
							container
							item
							justifyContent="space-between"
						>
							<div style={{ display: "flex", alignItems: "center"}}>
								<Photo 
									hover
									name={inb003.inb003Efa005Nome}
									link={inb003.inb003Efa005Imagem && `${REACT_APP_S3_ADDRESS}/${REACT_APP_S3_DIRECTORY}/imagens_usuarios/${inb003.inb003Efa005Imagem}`}
									width={45}
									height={45}
								/>
								<ColumnFlex>
									<ContainerUser>
										<Title color="purple" size="md" styleInline="margin: 2px 5px 2px 5px;">
											{inb003.inb003Efa005Nome}
										</Title>
									</ContainerUser>
									<ContainerValues>								
										<Title color="grey" size="xs" styleInline="margin: 2px 5px 2px 5px;">
											{inb003.dateCreated && `${translate("Data postergação")}: ${formatDate(inb003.dateCreated, currentLanguage)}`}
										</Title>
										<Title color="grey" size="xs" styleInline="margin: 2px 5px 2px 5px;">
											{!inb003.inb003Aprovada ? (
												<>
													{inb003.dateCreated && (<>
														{translate("Nova data proposta")}: &nbsp; <span>{formatDate(inb003.inb003Dtfim, currentLanguage)}</span>
													</>)}
												</>
											) : (
												<>
													{inb003.dateCreated && (<>
														{translate("Data anterior")}: &nbsp; <span style={{ color: "var(--red)" }}>{formatDate(inb003.inb003Dtfim, currentLanguage)}</span>
													</>)}
												</>
											)}
										
										</Title>
										{badgeSituation(inb003.inb003Aprovada)}
									</ContainerValues>	
								</ColumnFlex>
							</div>
						</RCCGrid>
						<SpanComment>
							{inb003.inb003Justificativa}
						</SpanComment>
					</RCCGrid>
				))}

			</Modal>
		</>
	);
};

export default forwardRef(ModalShowPostponements);
